import { VALUE_TYPES } from "@/static/valueTypes";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class AttributeTemplate {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  attributeCode!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  attributePrototypeId!: number | null;
  @Expose()
  @IsOptional()
  @IsString()
  description!: null | string;
  @Expose()
  @IsEnum(VALUE_TYPES)
  valueType!: VALUE_TYPES;
  @Expose()
  @IsString()
  valueTypeName!: string;
  @Expose()
  @IsOptional()
  @IsString()
  defaultValue!: string;
  @Expose()
  @IsBoolean()
  isRequired!: boolean;
  @Expose()
  @IsBoolean()
  isPrintable!: boolean;
  @Expose()
  @IsOptional()
  @IsString()
  attributeSource!: null | string;
}

export class AttributeTemplateResponse extends GenericTableResponse<AttributeTemplate> {
  @Expose()
  @IsArray()
  @Type(() => AttributeTemplate)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<AttributeTemplate>;
}
